import Api from '.';
import { endpoints } from './endpoints';

export default class UserApi extends Api {

    getUsers(data) {
        let url = this.buildUrl(endpoints.user.getUser)

        return this.fetch(url, "GET").then(response => response);
    }

    menuRoleWise(data) {
        let url = this.buildUrl(endpoints.login.menuRoleWise)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }


    getParams(data) {
        let url = this.buildUrl(endpoints.login.getParams)
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response)
    }

    authedicate() {
        let url = this.buildUrl(endpoints.login.authedicate)
        return this.fetch(url, "GET").then(response => response);
    }

    masterMenu() {
        let url = this.buildUrl(endpoints.login.masterMenu)
        return this.fetch(url, "GET").then(response => response);
    }

    //SA Changes made for handling Popup --Abhishek
    //SA Code commented for DXTech issue
    // popupmenu(data) {
    //     let url = this.buildUrl(endpoints.login.popupmenu)
    //     // return this.fetch(url, "GET").then(response => response);
    //     return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    // }
    //EA Code commented for DXTech issue
    //EA Changes made for handling Popup --Abhishek

}